
import { useState } from 'react';
import { useSchedulerEmails } from './useSchedulerEmails';
import { useSchedulerCalls } from './useSchedulerCalls';
import { useSchedulerReservations } from './useSchedulerReservations';

export const useSchedulingAgent = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { emailStatus, sendAvailabilityEmail } = useSchedulerEmails();
  const { callStatus, callCandidate } = useSchedulerCalls();
  const { bookingStatus, bookReservation } = useSchedulerReservations();

  return {
    isProcessing,
    // Email operations
    emailStatus,
    sendAvailabilityEmail,
    // Call operations
    callStatus,
    callCandidate,
    // Reservation operations
    bookingStatus,
    bookReservation
  };
};
